import { render } from "./TournamentLeagueScoringFF.vue?vue&type=template&id=5297cf24&scoped=true"
import script from "./TournamentLeagueScoringFF.vue?vue&type=script&lang=js"
export * from "./TournamentLeagueScoringFF.vue?vue&type=script&lang=js"

import "./TournamentLeagueScoringFF.vue?vue&type=style&index=0&id=5297cf24&lang=scss&scoped=true"
import "./TournamentLeagueScoringFF.vue?vue&type=style&index=1&id=5297cf24&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5297cf24"]])

export default __exports__